import { useMemo } from 'react';

export const formatMemberName = (
  firstName?: string | null, 
  lastName?: string | null
): string => {
    return `${firstName ?? ''} ${lastName ?? ''}`.trim();
};

export const capitalizeFirstLetter = (str: string): string => {
    return str.charAt(0).toUpperCase() + str.slice(1);
};

export function formatPercent(
  valuePct: number | null | undefined, 
  locale: string, 
  digits: number = 2
): string {
  if (valuePct === null || valuePct === undefined) return '';

  return new Intl.NumberFormat(locale, {
    style: 'percent',
    minimumFractionDigits: digits,
    maximumFractionDigits: digits,
  }).format(valuePct / 100);
}

export function useFormatters(locale: string) {
  return useMemo(() => {
    const percent2 = new Intl.NumberFormat(locale, { 
      style: 'percent',
      minimumFractionDigits: 2,
      maximumFractionDigits: 2 
    });
    const percent = new Intl.NumberFormat(locale, {
      style: 'percent',
      minimumFractionDigits: 0,
      maximumFractionDigits: 0
    });

    return {
      number: new Intl.NumberFormat(locale),
      number2: new Intl.NumberFormat(locale, { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
      percent2,
      percent,
      percent2From100: (num: number | string) => percent2.format(Number(num) / 100),
      percentFrom100: (num: number | string) => percent.format(Number(num) / 100),
    };
  }, [locale]);
}
